<app-modal #modalWindow customClassName="size-md">
  <div class="modal-header">
    <h2 class="modal-title">Edit API Consumer</h2>
  </div>
  <div class="modal-body">

    <form [formGroup]="form" (submit)="onFormSubmit()">

      <table class="simple-form">
        <tr>
          <th><label>Consumer Name</label></th>
          <td>
            <div class="form-group">
              <input type="text" class="form-control" formControlName="name">
            </div>
          </td>
        </tr>
        <tr>
          <th><label>Webhook Url</label></th>
          <td>
            <div class="form-group">
              <input type="text" class="form-control" formControlName="webhookUrl">
            </div>
          </td>
        </tr>
        <tr>
          <th><label for="visit-count">Webhook Version</label></th>
          <td>
            <div class="form-group">
              <app-dropdown-input #webhookVersionSelect id="webhookVersion" [options]="webhookVersions"
                                  [parentForm]="form" name="webhookVersion" placeholder="Select Version..."></app-dropdown-input>
            </div>
          </td>
        </tr>
        <tr>
          <th></th>
          <td>
            <div style="display: flex; flex-direction: column; gap: 20px;">
              <app-switch-panel label="API Consumer Enabled" text="Allow this consumer to access the API" formControlName="enabled"></app-switch-panel>
              <app-switch-panel label="First Party Consumer" text="Treats the consumer as a PGO-run integration: its patients use PGO logins and PGO may contact them. Site access is still scoped. Cannot be changed once a linked trial has patients or sites." formControlName="firstPartyConsumer"></app-switch-panel>
              <app-switch-panel label="One Time Password Enabled" text="Allows login via a one-time password received via email" formControlName="oneTimePasswordEnabled"></app-switch-panel>
              <app-switch-panel label="Webhooks Enabled" text="Enable webhook notifications for this consumer" formControlName="webhooksEnabled"></app-switch-panel>

              <div class="webhook-toggle-wrap" *ngIf="form.get('webhooksEnabled').value" style="display: flex; flex-direction: column; gap: 20px;">
                <app-switch-panel label="Patient Webhooks" text="Send notifications when patient data changes" formControlName="webhooksEnabledPatient"></app-switch-panel>
                <app-switch-panel label="Expense Webhooks" text="Send notifications when expense data changes" formControlName="webhooksEnabledExpense"></app-switch-panel>
                <app-switch-panel label="Visit Webhooks" text="Send notifications when visit data changes" formControlName="webhooksEnabledVisit"></app-switch-panel>
                <app-switch-panel label="Trip Webhooks" text="Send notifications when trip data changes" formControlName="webhooksEnabledTrip"></app-switch-panel>
              </div>
            </div>
          </td>
        </tr>

      </table>

    </form>

  </div>
  <div class="modal-footer">
    <div class="row">
      <div class="col-6">
        <a (click)="modalWindow.hide()" class="btn btn-secondary" data-dismiss="modal">Cancel</a>
      </div>

      <div class="col-6">
        <button type="button" (click)="onFormSubmit()" class="btn btn-primary" [disabled]="isProcessing || !form.valid">
          <span *ngIf="isProcessing">
                            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                          </span>
          <span *ngIf="!isProcessing">Save API Consumer</span>
        </button>
      </div>
    </div>
  </div>
</app-modal>
